import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg
    aria-hidden="true"
    className={className}
    data-ffid="img-close-icon"
    viewBox="0 0 18 18"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 3L15 1.5L9 7.5L3 1.5L1.5 3L7.5 9L1.5 15L3 16.5L9 10.5L15 16.5L16.5 15L10.5 9L16.5 3Z"
      className="fill-[#333] dark:fill-white"
    />
  </svg>
);

export default Icon;
